export const query = `query getCheckoutSettings {
  checkoutSettings {
    termsAndConditions {
      value
      enabled
    }
  }
}`;
